import InformarApi from "../../apis/Informar";

export default {
  namespaced: true,
  state: {
    prosecutions: [],
    sale: undefined,
    generate_pdf:undefined,
    paginated:{}
  },
  mutations: {
    set_prosecutions(state, data) {
      state.prosecutions = data;
    },
    set_sale(state, data) {
      state.sale = data;
    },
    set_generatePdf(state, data) {
      state.generate_pdf = data;
    },
    set_paginated (state, data) {
      state.paginated =  data
    }
  },
  actions: {
    emptyServices({ commit }) {
      commit("set_prosecutions", []);
    },
    newProsecutions({ commit, dispatch }, value) {
      commit("set_prosecutions", value);
    },
    resetSale({ commit }) {
      commit("set_sale", null);
    },
    async getProsecution({ commit, dispatch }, filters) {
      return await InformarApi.get_allPaginated(filters)
        .then((response) => {
          commit('set_paginated', {
            ...response.data
          })
          commit("set_prosecutions", response.data.data);  
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar servicios, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async getSaleByOrden({ commit, dispatch }, value) {
      return await InformarApi.getSaleByOrden(value)
        .then((response) => {
          commit("set_sale", response.data);
          // dispatch(
          //   "notifications/store_notification",
          //   {
          //     type: "success",
          //     message: "El registro se realizó de forma correcta.",
          //   },
          //   { root: true }
          // );
          // dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al registrar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async store({ dispatch }, informar) {
      return await InformarApi.store(informar)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al registrar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },

    async update({ dispatch }, informar) {
      return await InformarApi.update(informar)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La actualización se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al actualizar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, informar) {
      return await InformarApi.delete(informar)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La eliminación se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status({ dispatch }, informar) {
      let action = informar.active ? "inactivación" : "activación";
      return await InformarApi.change_status(informar)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La " + action + " se relizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status_confirmado({ dispatch }, informar) {
      let action = informar.state_report == 'confirmado' ? "desconfirmo" : "confirmo";
      return await InformarApi.change_status_confirmado(informar)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El informe se " + action + " de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async generatePdf({commit, dispatch }, {id, office_id}) {
      return await InformarApi.generatePdf(id, office_id)
        .then((response) => {
          commit("set_generatePdf", response.data);
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "Se genero el PDF de forma correcta.",
            },
            { root: true }
          );
          // dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar realizar generar el PDF vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
  },
};
